import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { T } from "../tokens";
import { Btn } from "../components/Btn";
import { AuthShell } from "../components/AuthShell";

const inputStyle: React.CSSProperties = {
  width: "100%", padding: "10px 12px", background: T.s2, border: `1px solid ${T.b1}`,
  borderRadius: "7px", color: T.t0, fontFamily: T.body, fontSize: "13px", outline: "none",
};

const cardStyle: React.CSSProperties = {
  width: "100%", padding: "32px", background: T.s1,
  border: `1px solid ${T.b0}`, borderRadius: "12px",
};

export function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [sent, setSent]   = useState(false);
  const [busy, setBusy]   = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      // Response is intentionally the same whether or not the account exists.
      await axios.post("/api/auth/forgot-password", { email });
    } catch { /* never reveal failures — show the same generic state */ }
    finally { setBusy(false); setSent(true); }
  }

  return (
    <AuthShell>
      <div style={cardStyle}>
        {sent ? (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "34px", marginBottom: "8px" }}>✉️</div>
            <h1 style={{ fontFamily: T.display, fontSize: "20px", fontWeight: 700, color: T.t0, margin: "0 0 8px" }}>
              Check your email
            </h1>
            <p style={{ fontFamily: T.body, fontSize: "13px", color: T.t2, lineHeight: 1.6, margin: "0 0 20px" }}>
              If an account exists for <strong style={{ color: T.t1 }}>{email}</strong>, we've sent a
              link to reset your password. It expires in 1 hour.
            </p>
            <Btn variant="outline" size="md" onClick={() => navigate("/login")}>Back to sign in</Btn>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: "20px" }}>
              <h1 style={{ fontFamily: T.display, fontSize: "22px", fontWeight: 700, color: T.t0, margin: 0 }}>
                Reset your password
              </h1>
              <p style={{ fontFamily: T.body, fontSize: "13px", color: T.t2, marginTop: "6px" }}>
                Enter your email and we'll send you a reset link.
              </p>
            </div>
            <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <input style={inputStyle} type="email" placeholder="Email" autoComplete="email"
                value={email} onChange={e => setEmail(e.target.value)} required />
              <Btn type="submit" variant="cta" size="md" disabled={busy}>
                {busy ? "Sending…" : "Send reset link"}
              </Btn>
            </form>
            <p style={{ fontFamily: T.body, fontSize: "12px", color: T.t2, textAlign: "center", marginTop: "16px" }}>
              <button type="button" onClick={() => navigate("/login")}
                style={{ background: "none", border: "none", color: T.tealSoft, cursor: "pointer", fontFamily: T.body, fontSize: "12px" }}>
                Back to sign in
              </button>
            </p>
          </>
        )}
      </div>
    </AuthShell>
  );
}
